export function getHeroContentImageAccordingWithUserSex(currentUser) {
    const path = 'home/assets/images/congratulations/';
    const images = {
        male: {
            mobile: 'hero-content-male-mobile.svg',
            desktop: 'hero-content-male.svg',
        },
        female: {
            mobile: 'hero-content-female-mobile.svg',
            desktop: 'hero-content-female.svg',
        },
    };
    const isAMobileDevice = window.innerWidth <= 1024;

    if (currentUser.genderDescription === "Masculino") {
        return `${path}${isAMobileDevice ? images.male.mobile : images.male.desktop}`;
    } else {
        return `${path}${isAMobileDevice ? images.female.mobile : images.female.desktop}`;
    }
}

class BlipChatControl {
    public getBlipChatContainerElm() {
        return window.document.getElementById('blip-chat-container');
    }

    public getBlipChatElm() {
        return window.document.getElementById('blip-chat-open-iframe');
    }

    public hideChat() {
        this.getBlipChatElm().style['display'] = 'none';
    }

    public showChat() {
        this.getBlipChatElm().style['display'] = 'block';

        return this;
    }

    public openChat() {
        this.showChat()
            .getBlipChatElm()
            .click();
    }
}

export const BlipChatControlSingleton = new BlipChatControl;
